<template>
    <div>
        <p class="text-sm font-medium text-iron-700">Round robin</p>
        <div
            class="mt-2 flex max-w-[300px] flex-col rounded-lg border border-iron-200"
        >
            <div
                class="flex items-center gap-4 border-iron-200 px-2 py-2"
                v-for="user of usersWithAssignment"
                :key="user.id"
            >
                <img
                    class="h-10 w-10 rounded-full"
                    :src="user.profile_photo_url"
                    :alt="user.name"
                />
                <p class="grow">
                    {{ user.name }}
                </p>

                <Switch
                    :checked="user.assigned"
                    @update:checked="handleAssignmenChange(user)"
                ></Switch>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import { EventType } from "../types/EventType";
import { computed } from "vue";
import { Switch } from "@/components/ui/switch";

interface User {
    id: number;
    name: string;
    profile_photo_url: string;
}

const props = defineProps<{
    users: User[];
    eventType: EventType;
}>();

interface UserWithAssignement extends User {
    assigned: boolean;
}

const usersWithAssignment = computed(() => {
    const users: UserWithAssignement[] = [];

    props.users.forEach((user: User) => {
        const found = props.eventType.users.find(
            (userFind) => userFind.user_id === user.id,
        );

        if (found) {
            users.push({ ...user, assigned: true });
        } else {
            users.push({ ...user, assigned: false });
        }
    });

    return users;
});

function handleAssignmenChange(user: UserWithAssignement) {
    if (user.assigned) {
        removeUserFromEventType(user);
    } else {
        assignUserToEventType(user);
    }
}

function assignUserToEventType(user: User) {
    router.post(
        route("app.event-types.users.store", {
            eventType: props.eventType.id,
        }),
        {
            user_id: user.id,
        },
    );
}

function removeUserFromEventType(user: User) {
    router.delete(
        route("app.event-types.users.delete", {
            user: user.id,
            eventType: props.eventType.id,
        }),
    );
}
</script>
